import { useEffect, useState } from "react"
import { formatDate, Text, useMainContext } from "../../../../../modules/Dashboard"
import { useSwapHistoryQuery } from "../../../../../core/services/react-query/swap"
import { Column, Row } from "../../../../../styles/TableStyle"
import { FlexCenter, FlexColumn, FlexStart } from "../../../../../styles/CommonStyles"
import { SOCKET_URL } from "../../../../../core/constants/urls"
import SwapIcon from "../../../../../components/icons/SwapIcon"
import CoinImg from "../../../../../components/common/CoinImg"
import { ScaleLoader } from "react-spinners"
import CalenderIcon from "../../../../../components/icons/CalenderIcon"
import { formatDateShort } from "../../../../plans/components/CurrentUserPlan/helper"
import SuccessIcon from "../../../../../components/icons/SuccessIcon"
import FailedIcon from "../../../../../components/icons/FailedIcon"

const SwapHistoryWidget = () => {
    const {
        main: { lang },
    } = useMainContext()

    const [filterQueries] = useState({
        page: 1,
        dateFrom: null,
        search: {},
        query: {},
    })

    const { data: orders, isFetching, refetch } = useSwapHistoryQuery(filterQueries)

    useEffect(() => {
        refetch()
    }, [refetch])


    return (
        <div className="h-full">
            <div className='relative flex justify-between gap-1 items-center pb-4'>
                <Text tid={"swap-history"} className='text-xl' />
                <Text tid={"all"} className='underline text-mainColor' />
            </div>
            {
                isFetching &&
                <div className="p-4 text-center text-sm text-gray-500"><ScaleLoader size={20} color='#9F64DF' /></div>
            }
            {orders?.data?.slice(0, 5).map((item) => (
                <div key={item._id} className="p-4 !bg-[#1E1533] border border-[#36415380] rounded-xl my-2 relative hover:scale-[1.02] transition-all">
                    {/* Currencies */}
                    <FlexColumn className="gap-3 ltr:pl-3 rtl:pr-3">
                        <span className='flex items-center gap-1 text-[#FC6432] text-sm'>
                            <CalenderIcon color='#FC6432' size={16} className="inline " />
                            {
                                formatDateShort(item?.createdAt, lang)
                            }
                        </span>
                        <FlexStart className="gap-1">
                            <img
                                src={SOCKET_URL + `assets/icon/${item.fromCurrency.toUpperCase()}-${item.toCurrency.toUpperCase()}.png`}
                                alt={item.fromCurrency}
                                width="40px"
                                height="40px"
                            />
                            <span className="uppercase font-bold">{item.fromCurrency}</span>
                            <SwapIcon color="#FC6432" size={26} />
                            <span className="uppercase font-bold">{item.toCurrency}</span>
                        </FlexStart>
                    </FlexColumn>
                    <div className="absolute top-6 ltr:right-4 rtl:left-4">
                        <span
                            className={`px-2 py-1 flex gap-1 items-center justify-center rounded-full text-sm max-w-max border ${item.status === "done"
                                ? "bg-[#00C9501A] text-[#05DF72] border-[#00C9504D]"
                                : item.status === "pending"
                                    ? "bg-yellow-200 text-yellow-800"
                                    : "bg-[#FF64671A] border-[#FF64674D] text-[#FF6467]"
                                }`}
                        >
                            {
                                item.status === "done" ?
                                    <SuccessIcon color="#05DF72" /> :
                                    item.status === "failed" ?
                                        <FailedIcon color="#FF6467" /> :
                                        <></>
                            }
                            <Text tid={item.status} className="text-inherit" />
                        </span>
                    </div>

                </div>
            ))}
            {
                !isFetching && !orders?.data?.length ?
                    <div className='flex flex-col justify-start items-center h-full'>
                        <img src={require('../../../../../assets/images/trading-pro/no-data.webp')} width={100} height={100} alt="" className='my-5' />
                        <Text tid={"list-is-empty"} />
                    </div> :
                    null
            }
        </div>
    )
}

export default SwapHistoryWidget
